import { CollectionView } from "@/types/collection"

export const COLLECTION_VIEW_DEFAULT: CollectionView = undefined

export const COLLECTION_PLACES_PER_PAGE = 96
